import { mapValues } from '@toss/utils';
import { type SupportedLocaleMap } from '@zep-us/i18n';
import { groupBy } from 'lodash-es';

import type { MapTemplateUserRes } from '@/api/gen/_model/mapTemplateUserRes';
import {
  type MapTemplate,
  type MapTemplateLocalize,
  type MapTemplateType,
} from '@/types';

export const transformMapTemplate = (
  data: MapTemplateUserRes[],
): MapTemplate[] =>
  data.map(d => {
    const _localizeData = d.localizeData.concat({
      description: d.description,
      name: d.name,
      previewPlayUrl: d.previewPlayUrl,
      type: d.type,
      locale: 'ko',
    });
    return {
      ...d,
      type: d.type as MapTemplateType,
      serializedLocalize: mapValues(
        groupBy<MapTemplateLocalize>(_localizeData, 'locale'),
        list => list[0] ?? {},
      ) as SupportedLocaleMap<'ko' | 'en' | 'ja', MapTemplateLocalize>,
    };
  });
